/* eslint-disable prettier/prettier */
import axios from 'axios'

const state = {
    clients: {},
    client: {},
    isLoadingTable: false,
    showDeleteModal: false
}

const mutations = {
    getPaginatedClients(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/clients/page=${payload.page}&pageSize=${payload.pageSize}/${payload.query}`).then(response => {
            state.clients = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isLoadingTable = false)
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.client) {
            state.client = payload.client
        } else {
            state.client = {}
        }
    }
}

const actions = {
    getPaginatedClients({
        commit
    }, payload) {
        commit('getPaginatedClients', payload)
    },
    openDeleteModal({
        commit
    }, payload) {
        commit('openDeleteModal', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}